import { GetStaticProps } from "next";
import React, { useEffect } from "react";
import SEOTags from "../components/seo-tags";

const BlogPage = () => {
  useEffect(() => {
    window.location.href = "https://blog.catlog.shop";
  }, []);

  return (
    <>
      <SEOTags
        tags={{
          title: "Blog | Catlog",
          description: "Catlog how-to's, thoughts on social commerce & folks behind the scenes",
          image: "https://res.cloudinary.com/catlog/image/upload/v1671181436/seo-banners/Blog_Banner.png",
          pageUrl: "/blog",
        }}
      />
      <div className="h-screen w-screen grid place-items-center">
        <span className="text-placeholder text-1sm">Redirecting....</span>
      </div>
    </>
  );
};

export default BlogPage;

export const getStaticProps: GetStaticProps = () => {
  return {
    props: {},
  };
};
